<div class="component-container">

  <ng-container [ngSwitch]="viewMode">

    <div class="location-card" *ngSwitchCase="'trailerView'">
      <div class="card-header">
        <div class="location-title">
          <h2 class="location-name" id="displayName"><strong>Check in Trailer</strong></h2>
          <p class="location-id" id="displayId"><button mat-raised-button color="warn" (click)="switchView()">
              Add new yard spot
            </button></p>
        </div>
      </div>

      <div class="objects-section">
        <form #addTrailerForm="ngForm" (ngSubmit)="checkInTrailer(addTrailerForm)">
          <div class="form-group">
            <label class="form-label" for="editOccupancy">Yard Spot</label>

            <select [(ngModel)]="targetSpot.location" name="spot" class="form-input" required>
              <option class="form-input" *ngFor="let yard of openYardSpots" [value]="yard.location">
                {{ yard.location }}
              </option>
            </select>
          </div>
          <div *ngIf="openYardSpots.length == 0">
            <p>No open spot available</p>
          </div>
          <div class="form-group">
            <label class="form-label">PO#</label>
            <input class="form-input" type="text" matInput maxlength="10" placeholder="PO" name="po"
              [ngModel]="targetSpot?.trailer?.po" #po [disabled]="openYardSpots.length == 0" />

          </div>
          <div class="form-group">
            <label class="form-label">Trailer Number</label>
            <input class="form-input" type="text" matInput maxlength="10" placeholder="Trailer Number"
              name="trailerNumber" [ngModel]="targetSpot.trailer.trailer" required #trailerNumber
              [disabled]="openYardSpots.length == 0" />

          </div>
          <div class="form-group">
            <label class="form-label">Carrier</label>
            <input class="form-input" type="text" matInput placeholder="Carrier" maxlength="10" name="carrier"
              [ngModel]="targetSpot.trailer.carrier" required #carrier [disabled]="openYardSpots.length == 0" />
          </div>
          <div class="form-group">
            <label class="form-label">Status</label>
            <select class="form-input" [ngModel]="targetSpot.status" name="status" required>
              <option *ngFor="let status of trailerStatus" [value]="status">{{
                status
                }}</option>
            </select>
          </div>
          <button mat-raised-button class="btn-save" color="primary" type="submit" [disabled]="!addTrailerForm.form.valid"
            #addTrailerFormSubmitBtn>
            Add
          </button>
        </form>
      </div>
    </div>
    <div class="location-card" *ngSwitchCase="'yardView'">
      <div class="card-header">
        <div class="location-title">
          <h2 class="location-name"><strong>Add New Yard Spot</strong></h2>
          <p class="location-id"><button mat-raised-button color="warn" (click)="switchView()">
              Check in trailer
            </button></p>
        </div>
      </div>
      <div class="objects-section">
        <form #addSpotForm="ngForm" (ngSubmit)="addSpot(addSpotForm)">
          <div class="form-group">
            <label class="form-label">Yard Spot</label>
            <input class="form-input" type="text" matInput placeholder="Yard Spot" name="spot" #spot="ngModel"
              [(ngModel)]="targetSpot.location" required />
            <span class="text-danger" *ngIf="spot.touched && spot.errors?.required">Location is required</span>
          </div>

          <label class="form-label">Add Trailer?</label>
          <mat-radio-group [(ngModel)]="hasTrailer" name="hasTrailer" class="radio-btns">
            <mat-radio-button [value]="false">No Trailer</mat-radio-button>
            <mat-radio-button [value]="true">With Trailer</mat-radio-button>
          </mat-radio-group>

          <div class="form-group">
            <label class="form-label">PO#</label>
            <input class="form-input" type="text" placeholder="PO" name="po" [(ngModel)]="targetSpot.trailer.po"
              [disabled]="!hasTrailer" />
          </div>
          <div class="form-group">
            <label class="form-label">Trailer Number</label>
            <input class="form-input" type="text" matInput placeholder="Trailer Number" name="trailerNumber"
              #trailer="ngModel" [(ngModel)]="targetSpot.trailer.trailer" [required]="hasTrailer"
              [disabled]="!hasTrailer" />
            <span class="text-danger" *ngIf="trailer.touched && trailer.errors?.required">Trailer is required</span>

          </div>
          <div class="form-group">
            <label class="form-label">Carrier</label>
            <input class="form-input" type="text" placeholder="Carrier" name="carrier" #carrier="ngModel"
              [(ngModel)]="targetSpot.trailer.carrier" [required]="hasTrailer" [disabled]="!hasTrailer" />
            <span class="text-danger" *ngIf="carrier.touched && carrier.errors?.required">Carrier is required</span>

          </div>
          <div class="form-group">
            <label class="form-label">Status</label>
            <select class="form-select" [(ngModel)]="targetSpot.trailer.status" [required]="hasTrailer" name="status"
              [disabled]="!hasTrailer" #status>
              <option *ngFor="let status of trailerStatus" [value]="status">{{
                status
                }}</option>
            </select>
          </div>
          <button mat-raised-button class="btn btn-save" [disabled]="!addSpotForm.valid" color="primary" type="submit"
            #addSpotFormSubmitBtn>
            Add
          </button>
        </form>
      </div>
    </div>
  </ng-container>
</div>